import { mapActions, mapGetters } from 'vuex'
import { range } from 'lodash'
import globaltypes from '../../store/globaltypes'
import infoline from '../../components/infoline'
import { getAllLinkedProductIds } from '../../helpers/crops'

export default {
  name: 'cropinfo',
  components: { infoline },
  props: ['crop'],
  data () {
    return {
      isProductsPanelOpen: [false]
    }
  },
  computed: {
    ...mapGetters({
      groupedProducts: globaltypes.products.getters.groupByCategory,
      areProductsLoaded: globaltypes.products.getters.areProductsLoaded
    }),
    productIDs () {
      return getAllLinkedProductIds(this.crop)
    },
    isLoadingProducts () {
      return !this.areProductsLoaded(this.productIDs)
    },
    linkedProds () {
      if (!this.crop) return []
      return this.groupedProducts(this.productIDs)
    },
    numMethods () {
      return parseInt(this.crop['number_of_methods'])
    },
    growingCycles () {
      return range(1, this.numMethods + 1).map(i => {
        return this.crop[`method${i}_methodname`] + ': ' + this.crop[`method${i}_growing_cycle`] + ` ${this.$t('crops.days').toLowerCase()}`
      })
    },
    spaceBetweenPlants () {
      return range(1, this.numMethods + 1).map(i => {
        return this.crop[`method${i}_methodname`] + ': ' + this.crop[`method${i}_space_between_plants`] +
          'cm (' + this.$t('crops.plant') + ') × ' + this.crop[`method${i}_space_between_rows`] + 'cm (' + this.$t('crops.row') + ')'
      })
    },
    sun () {
      switch (this.crop['sun_exposure']) {
        case 'few': return 1
        case 'medium': return 2
        default: return 3
      }
    },
    water () {
      switch (this.crop['watering']) {
        case 'few': return 1
        case 'medium': return 2
        default: return 3
      }
    },
    frostResistance () {
      switch (this.crop['frost_resistance']) {
        case 'no': return this.$t('crops.no')
        case 'yes': return this.$t('crops.yes')
        default: return this.$t('crops.moderate')
      }
    },
    knownvarieties () {
      if (this.productIDs.length === 0) return []
      return this.groupedProducts(this.productIDs)
    },
    goodNeighbours () {
      if (!this.crop['good_neighbours']) return []
      var list = this.crop['good_neighbours'].indexOf(';') > -1 ? this.crop['good_neighbours'].split('; ') : this.crop['good_neighbours'].split(', ')
      list.pop()
      return list.map(x => x.replace(/\[.*\] /, ''))
    },
    badNeighbours () {
      if (!this.crop['bad_neighbours']) return []
      var list = this.crop['bad_neighbours'].indexOf(';') > -1 ? this.crop['bad_neighbours'].split('; ') : this.crop['bad_neighbours'].split(', ')
      list.pop()
      return list.map(x => x.replace(/\[.*\] /, ''))
    }
  },
  watch: {
    isProductsPanelOpen (val) {
      if (val[0]) this.loadProducts(this.productIDs)
    }
  },
  methods: {
    ...mapActions({
      addToCart: globaltypes.shoppingcart.actions.addItemToCart,
      loadProducts: globaltypes.products.actions.loadList
    }),
    addProductToCart (productID, variationID) {
      this.addToCart({
        productID,
        cropID: this.crop['key'],
        variationID
      })
      this.$ga.event({
        eventCategory: 'Product',
        eventAction: 'Product added to wishlist',
        eventLabel: `Added from page ${this.$route.name}`
      })
    }
  }
}
